import PropTypes from 'prop-types';
import { useContext } from 'react';
import { sanitiseText } from '../helpers/sanitiseText';
import ThemeContext from '../providers/ThemeProvider';
import ExpanderRelative from './_generic/expander/ExpanderRelative';

const AdditionalContent = ({ additionalContentText, isNewFilterApplied }) => {
  const theme = useContext(ThemeContext);
  const SEO_TEXT_MAX_HEIGHT = 180;
  const SEO_TEXT_MARGIN_BOTTOM = 20;

  return (
    <>
      <div className="additional-content container">
        <ExpanderRelative
          centeredButton
          marginBottom={SEO_TEXT_MARGIN_BOTTOM}
          maxHeight={SEO_TEXT_MAX_HEIGHT}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: sanitiseText(additionalContentText),
            }}
          />
        </ExpanderRelative>
      </div>
      <style jsx>{`
        .additional-content {
          margin-left: ${isNewFilterApplied ? '0px' : ''};
          max-width: ${isNewFilterApplied ? '900px' : '100%'};
          background-color: ${theme.commoncolors.white};
          margin-top: 10px;
          padding: 10px;
          border-radius: 5px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
        }
      `}</style>
    </>
  );
};

AdditionalContent.propTypes = {
  additionalContentText: PropTypes.string,
};

export default AdditionalContent;
